export default "__VITE_ASSET__f50a77e1__"